export default __webpack_public_path__ + "static/media/icon-SubdirectoryPrimary.c52625b1.svg";